import * as React from "react";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";

export default function Drawer({
  children,
  anchor = "right",
  open,
  setOpen,
  ...other
}) {
  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setOpen(!open);
  };

  return (
    <SwipeableDrawer
      anchor={anchor}
      open={open || false}
      onClose={toggleDrawer(anchor, false)}
      onOpen={toggleDrawer(anchor, true)}
      PaperProps={{
        className: "!rounded-none pt-[58px] min-w-[350px]",
      }}
      swipeAreaWidth={0}
      {...other}
    >
      {children}
    </SwipeableDrawer>
  );
}
